import {Navbar, Nav, Button} from 'react-bootstrap';

import logo from './images/logo.png';
//import sslogo from './images/sslogo.png';
import sslogo from './images/bluelogo.png';


export default function Menu() {
	return (
	<div>
    <Navbar style={{background: "#e8daef", borderBottom: "solid 2px lightgrey"}}  className='fixed-top' expand="lg">
  <Navbar.Brand href="#home"><img src={logo} height={50} style={{paddingLeft: '10px'}} alt='sslogo' /><img src={sslogo} alt='senior spray type logo' height={35}/></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav className="ms-auto">
      <Nav.Link  href="/#home"><h5 className='hhlink_blue'>Home</h5></Nav.Link>
      <Nav.Link href="/#about"><h5 className='hhlink_lightBlue'>About</h5></Nav.Link>
      <Nav.Link href="/#contact"><h5 className='hhlink_blue'>Contact</h5></Nav.Link>
    </Nav>
	<Nav>
	  <Nav.Link href='/confirm'><Button className='btn-success'>Buy Now</Button></Nav.Link>
	</Nav>
  </Navbar.Collapse>
</Navbar>
<br />
<br />
<br />
</div>
);
}
